import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function G() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar60w');
    const IMG_SPECS_EU = ['eu', 'de', 'fr', 'it', 'es', 'kr'];

    return (
        <div className={`solar-60w-G ${css['solar-60w-G']}`}>
            <div className="text-box">
                <p className="title">{t('sec7_title')}</p>
                <p className="desc">
                    {t.rich('sec7_desc', {
                        black: (text: string) => <span className="black">{text}</span>,
                    })}
                </p>
            </div>
            <div className="img-box">
                <NextImage
                    src={require(`@publicLocal/solar-60w/pc/7${IMG_SPECS_EU.includes(locale) ? '_eu' : locale === 'uk' ? '_uk' : ''}.jpg`)}
                    alt={t('sec7_title')}
                    aria-label={t('sec7_title')}
                />
            </div>
        </div>
    );
}
